/*
 * Lazy mobile menu. The menu drawer ships only the top level; each department's
 * sub-menu is a <ul data-yc-menu-panel="handle"> holding a "View all <dept>" link.
 * On the first touch/hover/focus of the drawer we fetch every department's
 * sub-links in one request (sections/yc-menu-drawer-panels.liquid) and swap them
 * in. If the fetch fails, the "View all" links stay, so the menu still works.
 */
(function () {
  if (window.__ycLazyMenu) return;
  window.__ycLazyMenu = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url = root + '?section_id=yc-menu-drawer-panels';
  var pending = null;
  var done = false;

  function markCurrent(scope) {
    var here = location.pathname.replace(/\/$/, '');
    scope.querySelectorAll('a[href]').forEach(function (a) {
      if (a.pathname.replace(/\/$/, '') !== here) return;
      a.setAttribute('aria-current', 'page');
      if (a.classList.contains('menu-drawer__menu-item')) a.classList.add('menu-drawer__menu-item--active');
    });
  }

  function fill(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    document.querySelectorAll('ul[data-yc-menu-panel]').forEach(function (ul) {
      var tpl = doc.querySelector('template[data-yc-panel="' + CSS.escape(ul.getAttribute('data-yc-menu-panel')) + '"]');
      if (!tpl) return;
      ul.innerHTML = tpl.innerHTML;
      ul.removeAttribute('data-yc-menu-panel');
      markCurrent(ul);

      // The drawer (assets/global.js MenuDrawer) wires its <summary> elements once,
      // when it connects, so wire the ones we just added the same way.
      var drawer = ul.closest('header-drawer');
      var summaries = ul.querySelectorAll('summary');
      if (drawer && typeof drawer.onSummaryClick === 'function') {
        drawer.addAccessibilityAttributes(summaries);
        var onClick = drawer.onSummaryClick.bind(drawer);
        summaries.forEach(function (s) { s.addEventListener('click', onClick); });
      }
    });
    // Panels with no matching template keep their "Shop all" link; drop their loading rows.
    document.querySelectorAll('ul[data-yc-menu-panel] .yc-skel').forEach(function (el) { el.remove(); });
    done = true;
  }

  function load() {
    if (done || pending) return;
    pending = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(fill)
      .catch(function () {
        // keep the "Shop all" links; drop the loading placeholders
        document.querySelectorAll('ul[data-yc-menu-panel] .yc-skel').forEach(function (el) { el.remove(); });
      })
      .then(function () { pending = null; });
  }

  function arm() {
    document.querySelectorAll('header-drawer').forEach(function (el) {
      ['pointerdown', 'mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        // Not { once: true }: load() is a no-op once the panels are in, and after a failed
        // fetch the next touch (e.g. opening a department) tries again.
        el.addEventListener(ev, load, { passive: true });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
